module.exports = __webpack_public_path__ + "static/test2-0b7cb425aa155a8608c28786b641122b.jpg";